<style scoped>
    .togs_of{
        margin: 0px;
        text-align: center;
        text-transform: capitalize;
    }
    .community_chanel{
        text-transform: uppercase;
        text-align: center;
        margin: 0px;
    }
    .community_chanel2{
        text-transform: capitalize;
        text-align: center;
        margin: 0px;
    }
    .humtog_s{
        margin-bottom: 20px;
        background-color: #f5f8fa;
    }
    .comtt_c{
        border-left: none !important;
    }
    .community_togs{
        padding-left: 15px !important;
        list-style-type: none;
    }
</style>
<template>
    <div class="sidebar-right user-select comtt_c">
        <el-card class="box-card humtog_s">
            <h2 class="community_chanel">{{Store.page.channel.temp.name}}</h2>
            <p>{{Store.page.channel.temp.description}}</p>
        </el-card>
        <el-card class="box-card humtog_s">
            <h2 class="community_chanel2">Rules</h2>
            <p>{{Store.page.channel.temp.rules}}</p>
        </el-card>

<!--         <el-card class="box-card humtog_s">
            <h2 class="togs_of">Tags</h2>
            <p v-for="c in Store.page.channel.temp.relatedChannel">
                {{c.name}}
            </p>
        </el-card> -->
    </div>
</template>

<script>

    import Helpers from '../../mixins/Helpers';
    export default {
        mixins: [Helpers],
        data() {
            return {

            };
        },

        watch: {

        },

        computed: {

        },

        created() {

        },

        methods: {

        }
    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/sidebars/CommunitySideBar.vue